import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {PieChart} from '../components';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import {Insights} from '../components'
import {ChangeChartTitle} from '../components'
import {NonCustomersDetailEd} from '../components/edComponents';
import {NonCustomersDetailEdEnglish} from '../components/edComponents';
import {EdModal} from '../components/edComponents';
import Tooltip from '@material-ui/core/Tooltip';




const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    form: {
        '& > *': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    chart: {
      height: '100%',
      width: '900px',
      'background-image': `url(${process.env.PUBLIC_URL}/images/BlueNonCustemer.png)`,
      'background-repeat': 'no-repeat',
    },
    gridcolumn: {
      'margin-top': '250px',
      'margin-left': '125px',
    },
    grid: {
    },
    Button: {
      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7)'
    },
    buttonDelete: {
      float: 'right',
    },
    h1: {
      display: 'inline'
    },
    head: {
      display: 'flex',
    },
    chip: {
      maxWidth: '200px',
      whiteSpace: 'pre-line',
      backgroundColor: 'white',
      borderRadius: '15px',
      padding: '10px',
      boxShadow: theme.shadows[1],
      cursor: 'pointer'
    }
}));









function NonCustomersDetail({updateChart, selected, getDetailChart, match: {params: {projectId, chartId}}}) {
    React.useEffect(() => {
        getDetailChart(projectId, chartId)
    }, [projectId, chartId]);

    const [open, setOpen] = React.useState(false);
    const [openUpdate, setOpenUpdate] = React.useState(false);
    const [keys, setKeys] = React.useState({
      key: null
    });
    const [customerType, setCustomerType] = React.useState({
      type: null
    });

    const classes = useStyles();

    const [values, setValues] = React.useState({
        title: null,
        size: null,
        customerType: null,
        key: null,
        define: null,
        describe: null,
        data: [],
    });

    React.useEffect(
        () => {
            if (!selected) {
                return
            }
            setValues({...values, data: selected.data});
        }, [selected]
    );
    if (!selected) {
        return (
            <div>
                Not Found
            </div>
        )
    }

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };




    const handleClick = event => {
        const newData = [...selected.data];
        newData.push({
          'title': values.title,
          'size': values.size,
          'customerType': customerType,
          'define': values.define,
          'describe': values.describe
        })

        // console.log('newdata')
        // console.log(newData)

        setValues({data: newData});
        updateChart(projectId, chartId, {...selected, data: newData});
        setOpen(false);
    };

    const handleClickUpdate = event => {

      // console.log('handleClickUpdate',[...selected.data][keys.key])
      // console.log('handleClickUpdate',values)
      const newData = {
        'title': values.title === null ? selected.data[keys.key].title : values.title,
        'size': values.size === null ? selected.data[keys.key].size : values.size,
        'customerType': selected.data[keys.key].customerType,
        'define': values.define === null ? selected.data[keys.key].define : values.define,
        'describe': values.describe === null ? selected.data[keys.key].describe : values.describe
      }
      selected.data[keys.key] = newData
      // console.log([...selected.data][keys.key])

      // console.log('handleClickUpdate 2',values)
      updateChart(projectId, chartId, {...selected, data: selected.data})
      setOpenUpdate(false)
    }


    const chipClickDelete = event => {

      const newData = [...selected.data]

      newData.splice(event,1)

      setValues({data: newData})
      updateChart(projectId, chartId, {...selected, data: newData})
      setOpenUpdate(false)
    }

    const chipClickModal = (key) => {
      setOpenUpdate(true)
      console.log(key)
      setKeys({
        'key': key
      })

    }

    const typeCustemerClick = (type) => {
      setCustomerType(type)
      setOpen(true)

    }

    const closeModal = () => {
      setValues({
        title: null,
        size: null,
        customerType: null,
        key: null,
        define: null,
        describe: null,
        data: [],
      })
      setOpenUpdate(false)
    }

    const closeModalAdd = () => {
      setValues({
        title: null,
        size: null,
        customerType: null,
        key: null,
        define: null,
        describe: null,
        data: [],
      })
      setOpen(false)
    }

    const ChipTip = ({number, obj}) => {
      return (
        <>
          <Tooltip
            arrow
            title={
                <>
                  <div
                    style={{color: '#45adf7'}}>
                    Define
                  </div>
                  <div
                    style={{
                    whiteSpace: 'pre-line',
                    paddingBottom: 10,
                    fontSize: 16,
                    lineHeight: 1.5
                  }}>
                    {obj.define}
                  </div>
                  <div
                    style={{color: '#45adf7'}}>
                    Describe
                  </div>
                  <div
                    style={{
                      whiteSpace: 'pre-line',
                      paddingBottom: 10,
                      fontSize: 16,
                      lineHeight: 1.5
                    }}>
                    {obj.describe}
                  </div>
                  <div
                    style={{color: '#45adf7'}}>
                    Size
                  </div>
                  <div
                    style={{
                      paddingBottom: 10,
                      fontSize: 16
                    }}>
                    {obj.size}
                  </div>
                </>
            }
            interactive
            placement="right">
              <div
                className={classes.chip}
                key={number}
                onClick={() => chipClickModal(number)}>
                {obj.title}
              </div>
          </Tooltip>
        </>
      )
    }


    return (
        <>
        <div
          className={classes.head}>
          <ChangeChartTitle
            selected={selected}
            projectId={projectId}
            chartId={chartId}
            title={<h1
              className={classes.h1}>NonCustomers | {selected.title} </h1>}/>
          <EdModal
            TextRu={NonCustomersDetailEd}
            TextEng={NonCustomersDetailEdEnglish}/>
        </div>
        <div
          className={classes.chart}>
            <Grid
              container spacing={0}
              className={classes.grid}>
              <Grid
                item xs={1}
                className={classes.gridcolumn}>
                <Button
                  className={classes.Button}
                  variant="contained"
                  color="primary"
                  onClick={() => typeCustemerClick(0)}
                >
                    + Add 1
                </Button>
                {Object.values(selected.data).map(
                  (obj, key) =>
                    <div
                      key={key}>
                      {obj.customerType === 0 &&
                          <List component="nav" aria-label="main mailbox folders" >
                            <div key={key}>
                              <ListItem
                                >
                                  <ChipTip
                                    number={key}
                                    obj={obj}
                                    />
                              </ListItem>
                            </div>
                          </List>
                      }
                    </div>
                )}
              </Grid>
              <Grid
                item xs={1}
                className={classes.gridcolumn}>
                <Button
                  className={classes.Button}
                  variant="contained"
                  color="primary"
                  onClick={() => typeCustemerClick(1)}
                >
                    + Add 2
                </Button>
                {Object.values(selected.data).map(
                  (obj, key) =>
                    <div
                      key={key}>
                      {obj.customerType === 1 &&
                          <List component="nav" aria-label="main mailbox folders">
                            <div key={key}>
                              <ListItem>
                                <ChipTip
                                  number={key}
                                  obj={obj}
                                  />
                              </ListItem>
                            </div>
                          </List>
                      }
                    </div>
                )}
              </Grid>
              <Grid
                item xs={1}
                className={classes.gridcolumn}>
                <Button
                  className={classes.Button}
                  variant="contained"
                  color="primary"
                  onClick={() => typeCustemerClick(2)}
                >
                    + Add 3
                </Button>
                {Object.values(selected.data).map(
                  (obj, key) =>
                    <div key={key}>
                      {obj.customerType === 2 &&
                          <List component="nav" aria-label="main mailbox folders">
                            <div key={key}>
                              <ListItem>
                                <ChipTip
                                  number={key}
                                  obj={obj}
                                  />
                              </ListItem>
                            </div>
                          </List>
                      }
                    </div>
                )}
              </Grid>
            </Grid>
          </div>

          <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              className={classes.modal}
              open={openUpdate}
              onClose={() => closeModal()}
          >
            <div className={classes.paper}>
                {selected.data[keys.key] && <>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          defaultValue={selected.data[keys.key].title}
                          label="Identify Buyer Group"
                          value={values.title}
                          onChange={handleChange('title')}/>
                      <TextField
                          id="define"
                          multiline
                          defaultValue={selected.data[keys.key].define}
                          label="Define why this is a NonCustomers"
                          value={values.define}
                          onChange={handleChange('define')}/>
                      <TextField
                          type="number"
                          defaultValue={selected.data[keys.key].size}
                          id="size"
                          label="Demand size"
                          value={values.size}
                          onChange={handleChange('size')}/>
                      <TextField
                          id="describe"
                          multiline
                          defaultValue={selected.data[keys.key].describe}
                          label="Describe how you assessed the demand"
                          value={values.describe}
                          rowsMax={4}
                          onChange={handleChange('describe')}/>

                  </form>
                  <br/>
                  <Button
                      className={classes.Button}
                      variant="contained"
                      color="primary"
                      onClick={() => handleClickUpdate(keys.key)}>
                      update
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.buttonDelete}
                    onClick={() => chipClickDelete(keys.key)}
                  >
                      Delete
                  </Button>

                </>}
            </div>
          </Modal>




        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => closeModalAdd()}
        >
            <div className={classes.paper}>
                <h2 id="simple-modal-title"> Add group</h2>
                <form
                    className={classes.form}
                    noValidate autoComplete="off">
                    <TextField
                        id="title"
                        label="Identify Buyer Group"
                        value={values.title}
                        onChange={handleChange('title')}/>
                    <TextField
                        id="define"
                        multiline
                        label="Define why this is a NonCustomers"
                        value={values.define}
                        onChange={handleChange('define')}/>
                    <TextField
                        type="number"
                        id="size"
                        label="Demand size"
                        value={values.size}
                        onChange={handleChange('size')}/>
                    <TextField
                        id="describe"
                        multiline
                        label="Describe how you assessed the demand"
                        value={values.describe}
                        rowsMax={4}
                        onChange={handleChange('describe')}/>

                </form>
                <br/>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClick}>
                    Add
                </Button>
            </div>
        </Modal>

        <PieChart
          data={selected.data}>
        </PieChart>



        <Insights
          selected={selected}
          projectId={projectId}
          chartId={chartId}/>


        </>
    )
}

const mapStateToProps = state => state.charts;
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(NonCustomersDetail)
